import React, { useState } from "react";
import { Change } from "./useChangesTracker";
import { formatFieldValue } from "./deepCompare";
import "./Admin.css";

interface ChangesPopoverProps {
  changes: Change[];
}

const ChangesPopover: React.FC<ChangesPopoverProps> = ({ changes }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="changes-popover-container">
      <span
        className="pending-changes-badge"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: "pointer" }}
      >
        {changes.length} alteração(ões) pendente(s)
      </span>

      {isOpen && (
        <>
          <div
            className="changes-popover-overlay"
            onClick={() => setIsOpen(false)}
          />
          <div className="changes-popover">
            <div className="changes-popover-header">
              <h3>Alterações Pendentes</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="changes-popover-close"
              >
                ✕
              </button>
            </div>
            <div className="changes-popover-content">
              {changes.map((change) => (
                <div key={change.id} className="changes-popover-item">
                  <div className="changes-popover-item-header">
                    <span className={`change-type change-type-${change.type}`}>
                      {change.type === "add" && "Adicionar"}
                      {change.type === "edit" && "Editar"}
                      {change.type === "delete" && "Excluir"}
                    </span>
                    <span className="changes-popover-section">
                      {change.section}
                    </span>
                  </div>
                  <div className="changes-popover-description">
                    {change.description}
                  </div>
                  {change.fieldChanges && change.fieldChanges.length > 0 && (
                    <div className="changes-popover-fields">
                      <strong>Campos alterados:</strong>
                      <ul>
                        {change.fieldChanges.map((fc, idx) => (
                          <li key={idx}>
                            <strong>{fc.field}:</strong>{" "}
                            <span className="field-old-value">
                              {formatFieldValue(fc.oldValue)}
                            </span>
                            {" → "}
                            <span className="field-new-value">
                              {formatFieldValue(fc.newValue)}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ChangesPopover;
